import { render, staticRenderFns } from "./TargetCell.vue?vue&type=template&id=21138878&scoped=true&"
import script from "./TargetCell.vue?vue&type=script&lang=js&"
export * from "./TargetCell.vue?vue&type=script&lang=js&"
import style0 from "./TargetCell.vue?vue&type=style&index=0&id=21138878&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21138878",
  null
  
)

export default component.exports